/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessLine } from '../models/BusinessLine';
import type { RegistrationRequestInput } from '../models/RegistrationRequestInput';
import type { SendRegistrationOtpInput } from '../models/SendRegistrationOtpInput';
import type { ValidateRegistrationRequestOtpInput } from '../models/ValidateRegistrationRequestOtpInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RegistrationService {

    /**
     * @param version 
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static createRegistrationRequest(
version: string,
requestBody?: RegistrationRequestInput,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Registration',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static sendOtp(
version: string,
requestBody?: SendRegistrationOtpInput,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Registration/Otp',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static validateOtp(
version: string,
requestBody?: ValidateRegistrationRequestOtpInput,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Registration/Otp/Validate',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @returns BusinessLine OK
     * @throws ApiError
     */
    public static listBusinessLines(
version: string,
): CancelablePromise<Array<BusinessLine>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Registration/BusinessLines',
            path: {
                'version': version,
            },
        });
    }

}
